import React, { useContext } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import NvEmoji from 'shared/components/nv-emoji';
import NvIcon from 'shared/components/nv-icon';
import { AngularServicesContext } from 'react-app';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import { format } from 'date-fns';
import AskNovoAIButton from './ask-novo-ai-button';
import HelpfulnessRating from './helpfulness-rating';
import QuestionText from './question-text';
import { responseDrawerState } from '../styles';
import { AskNovoAiState } from '../helpers';

interface ResponseDrawerStateProps {
  question?: string;
  onClick: () => void;
}

const ResponseDrawerState = ({
  question,
  onClick,
}: ResponseDrawerStateProps) => {
  const { catalogId } = useLecturePageParams();
  const { $state } = useContext(AngularServicesContext);
  const askNovoAi: AskNovoAiState = useSelector(
    (state) => state.app.askNovoAi,
  );

  const onClickLecturePage = (lecturePageId: number) => {
    $state.go('lecture-page', { catalogId, id: lecturePageId });
  };

  return (
    <>
      <div css={responseDrawerState}>
        <NvEmoji icon='light' size='large' />
        <div className='response-container'>
          <QuestionText question={askNovoAi?.response?.questionText || question} />
          <p className='answer'>{askNovoAi?.response?.answer?.trim()}</p>
          <div className='links-container'>
            {askNovoAi?.response?.certificateUrl && (
              <div className='link-wrapper'>
                <NvIcon icon='badge' className='color-primary' size='smallest' />
                <a href={askNovoAi?.response?.certificateUrl} className='link' target='_blank' rel='noopener noreferrer'>
                  {t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.ASK_NOVO_AI_DRAWER.CERTIFICATE_LINK()}
                </a>
              </div>
            )}
            {askNovoAi?.response?.liveEvents?.map((item) => (
              <div className='link-wrapper' key={item.id}>
                <NvIcon icon='zoom' className='color-primary' size='smallest' />
                <button type='button' className='link' onClick={() => onClickLecturePage(item.lecturePageId)}>
                  {/* format date MMM dd, yyyy hh:mm  */}
                  {format(new Date(item?.startTime), 'MMM dd, yyyy HH:mm')} | {item?.title}
                </button>
              </div>
            ))}
            {askNovoAi?.response?.referencedComponents?.map((item) => (
              <div className='link-wrapper' key={item.id}>
                <NvIcon icon='link' className='color-primary' size='smallest' />
                <button type='button' className='link' onClick={() => onClickLecturePage(item.lecturePage?.id)}>
                  {item?.lecturePage?.title}
                </button>
              </div>
            ))}
          </div>
          <HelpfulnessRating questionId={askNovoAi?.response?.id} />
          <AskNovoAIButton onClick={onClick}>
            {t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.ASK_NOVO_AI_DRAWER.ASK_ANOTHER_BUTTON()}
          </AskNovoAIButton>
        </div>
      </div>

    </>
  );
};

export default ResponseDrawerState;
